import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** POST `/srm/purchase-order/{poId}/stock-receipt`。建立入庫單。 */
export async function createPurchaseOrderStockReceipt(poId, payload) {
  const { data: raw } = await request.post(
    `/srm/purchase-order/${poId}/stock-receipt`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
